const getProductPathname = ({ sku, slug }) => (sku && slug ? `/product/sku/${sku}/${slug}` : '')

export default getProductPathname
